/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Filter_Status_AllInputs */



/**
* | output |
* | --- |
* | "All Status" |
*
* @param {Manual_Qc_Filter_Status_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_filter_status_all = /** @type {((inputs?: Manual_Qc_Filter_Status_AllInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Filter_Status_AllInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tous les statuts")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Status")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutti gli stati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Все статусы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todos los estados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("所有状态")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべてのステータス")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी स्थितियाँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Todos os status")
	return /** @type {LocalizedString} */ ("All Status")
});